import { render, staticRenderFns } from "./regionPicker.vue?vue&type=template&id=3b9c1a09"
import script from "./regionPicker.vue?vue&type=script&lang=js"
export * from "./regionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports